import moment from 'moment'

var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

export const data = () => ({
  isDebug: true,
  toggle: false,
  requestCount: 1,
  loading: false,
  selectedParking: null,
  parkingSpaces: [],
  statusFilter: 'all',
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: true
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'spaceNumber',
      numeric: true,
      label: 'Number',
      aria: 'Number',
      width: '3%',
      sortable: true,
      searchable: true
    },
    {
      field: 'isCovered',
      label: 'Covered',
      aria: 'Covered',
      width: '2%',
      sortable: true,
      searchable: true
    },
    {
      field: 'note',
      label: 'Note',
      aria: 'Note',
      width: '30%',
      sortable: true,
      searchable: true
    },
    {
      field: 'unit',
      label: 'Unit',
      aria: 'Unit',
      width: '30%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    formRow: {
      padding: '10px',
      whiteSpace: 'nowrap'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
